import React, { useEffect, useState } from 'react';

import useGlobal from '../../../store';
import { Auth } from '../../../support';
import { FormControl } from '../../../facturotopia';
import LoadingButton from '../../../facturotopia/LoadingButton';
import { TheResult, TheError } from '../../../shared/responses/TheResult';

const mapState = (store) => {
  return {
    hits: store.cuenta.empresas.hits,
  };
};

const mapActions = (actions) => {
  return { hits: actions.cuenta.empresas.hits };
};

const EmpresaAssignacionHits = ({ data: empresa = {} }) => {
  const [_, setHitsBalance] = useState('cliente'); // eslint-disable-line
  const [state, actions] = useGlobal(mapState, mapActions);

  const { busy, data, result, error } = state.hits;

  useEffect(() => {
    const data = Auth.getData();
    const { cliente } = data;

    setHitsBalance(cliente.hits_balance);

    return () => {
      actions.hits.reset();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    actions.hits.change({
      empresa_id: empresa.id,
    });
  }, [empresa.id]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    return () => {
      actions.hits.reset();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleOnChange = (value) => {
    actions.hits.change(value);
  };

  return (
    <div>
      <div className="row">
        <div className="col-sm-5">
          <FormControl
            type="number"
            label="Cuántos hits vas a asignar?"
            name="hits"
            autoComplete="off"
            placeholder=""
            help=""
            value={data.hits || ''}
            onChange={handleOnChange}
          />
        </div>
      </div>

      {!!result && <TheResult result={result} />}

      {!!error && <TheError error={error} />}

      <div className="row">
        <div className="col">
          <LoadingButton
            type="button"
            disabled={busy || !parseInt(data.hits)}
            loading={busy || false}
            onClick={actions.hits.submit}
          >
            {busy ? 'Guardando...' : 'Guardar'}
          </LoadingButton>
        </div>
      </div>
    </div>
  );
};

export default EmpresaAssignacionHits;
